import { render } from "./Terms.vue?vue&type=template&id=5dfdac4c"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=5dfdac4c&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/home/circleci/project/times/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__